import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const ideagri: ImportTypeConfig = {
  dateField: {
    hiddenUnless: { field: 'spreadsheet-type', value: 'production' },
    requiredIf: {
      field: 'spreadsheet-type',
      messageKey: 'date',
      value: 'production',
    },
  },
  instructions: {
    // TODO - pensar em como melhorar isso, isso é exibido quando production está selecionado
    dateInstructionByType: {
      production: 'milk_production_date',
    },
    software: 'Ideagri',
    spreadsheetNameByType: {
      production: { messageKey: ['software_name', 'production'] },
      reproduction: { messageKey: ['software_name', 'reproduction'] },
    },
  },
  spreadsheet: {
    defaultValue: 'reproduction',
    instructions: [
      { name: 'reproduction-instructions', spreadsheetType: 'reproduction' },
      { name: 'production-instructions', spreadsheetType: 'production' },
    ],
    name: 'spreadsheet-type',
    options: [
      { labelKey: 'reproduction', value: 'reproduction' },
      { labelKey: 'production', value: 'production' },
    ],
  },
  type: 'ideagri',
}
